import React from 'react';

import ImageBlock from './ImageBlock';
import MarkdownText from '../MarkdownText';
import VideoBlock from './VideoBlock';

import './BasicMilestoneEntry.css';

export default ({ description, images, title, video, youtube }) => (
  <div className="BasicMilestoneEntry">
    {description && (
      <div className="BasicMilestoneEntry__description">
        <MarkdownText text={description} />
      </div>
    )}

    <ImageBlock imgs={images} />

    <VideoBlock video={video} />

    {youtube && (
      <iframe
        title={title}
        className="BasicMilestoneEntry__youtube"
        width="560"
        height="315"
        src={youtube}
        frameBorder="0"
        allowFullScreen
      />
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/timeline/BasicMilestoneEntry.js